import React from 'react';
// import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';
/* replace-start */
import './index.less';
/* replace-end */
class Footer3 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    const setHtml = (data) => {
      return data.map((value, index) => {
        return (
          <div {...value} key={index}>
            {value.children.map(getChildrenToRender)}
          </div>
        );
      });
    };

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div
          {...dataSource.bg}
          data-edit="image"
        >
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <div {...dataSource.page}>
          <TweenOne
            animation={{
              y: 0,
              duration: 900,
              delay: 150,
            }}
            style={{ transform: 'translateY(300px)' }}
            {...dataSource.center}
          >
            <div {...dataSource.left} data-edit="text">
              {
                React.createElement('span', { dangerouslySetInnerHTML: { __html: dataSource.left.children } })
              }
            </div>
            <div {...dataSource.right}>
              {
                setHtml(dataSource.right.children)
              }
            </div>
          </TweenOne>
        </div>
      </OverPack>
    );
  }
}
export default Footer3;
